import icon from "../../assets/fov.svg";
import type { Property } from "../../types";

export const fieldOfView: Property = {
  id: "fieldOfView",
  title: "fieldOfView.title",
  icon,
};
